import { PickingOrDispatchCabability } from "../../../../../core";

export const dispatchCapacityReport = {
  searchText: "",
  dialogHability: true,
  filter: false,
  checkbox: false,
  sort: false,
  paginator: true,
  partialField: "",
  columns: [
    {
      title: "Entidades",
      name: "entityCodes",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center w-dt-150",
      value: (element: PickingOrDispatchCabability) => element.entityCodes,
    },
    {
      title: "Tipo",
      name: "type",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: PickingOrDispatchCabability) => element.type,
    },
    {
      title: "Zona(s)",
      name: "zoneNames",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: PickingOrDispatchCabability) => element.zoneNames,
    },
    {
      title: "Capacidad generica o atributo",
      name: "generalOrAttributeInfo",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: PickingOrDispatchCabability) =>
        element.generalOrAttributeInfo,
    },
    {
      title: "Rango horario",
      name: "timeRange",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: PickingOrDispatchCabability) => element.timeRange,
    },
    {
      title: '',
      name: "capacityValue0",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[0].capacityValue
          : "-",
    },
    {
      title: '',
      name: "capacityValue1",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[1].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue2",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[2].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue3",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[3].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue4",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[4].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue5",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[5].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue6",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[6].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue7",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[7].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue8",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[8].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue9",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[9].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue10",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[10].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue11",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[11].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue12",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[12].capacityValue
          : "-",
    }, 
    {
      title: '',
      name: "capacityValue13",
      type: "string",
      editable: false,
      class: "center w-dt-120",
      checkAll: false,
      value: (element: PickingOrDispatchCabability) =>
        element.titles && element.titles.length > 0
          ? element.titles[13].capacityValue
          : "-",
    }, 
  ],
};
